import { Axis } from 'highcharts'

import type { ExtendedHighchartsOptions } from '~/types/graph-builder'

import { analyticsColors } from '~/const/chart'
import { formatExportFileName } from '~/utils/string'

const getGraphStackingOption = (graphType: string): 'normal' | 'percent' | undefined => {
  switch (graphType) {
    case 'stacked_column':
      return 'normal'
    case 'stacked_column_percent':
      return 'percent'
    default:
      return undefined
  }
}

export const getGraphOptions = (
  title: string,
  graphType: string,
  withOverallData: boolean
): ExtendedHighchartsOptions => {
  return {
    accessibility: {
      description: title,
    },
    chart: {
      events: {
        fullscreenClose: function () {
          //@ts-expect-error Property 'update' does not exist on type 'ChartEventsOptions'.
          this.update({
            tooltip: {
              outside: true,
            },
          })
        },
        fullscreenOpen: function () {
          //@ts-expect-error Property 'update' does not exist on type 'ChartEventsOptions'.
          this.update({
            tooltip: {
              outside: false,
            },
          })
        },
      },
      zooming: {
        mouseWheel: false,
        pinchType: undefined, // set 'x' here if you want a click & drag zoom
        type: undefined, // set 'x' here if you want a click & drag zoom
      },
    },
    colors: analyticsColors,
    credits: {
      enabled: false,
    },
    exporting: {
      csv: {
        columnHeaderFormatter: (item: Axis) => {
          if (!item || item instanceof Axis) {
            // return options?.exportColumnHeaderName || 'Date'
            return 'Name'
          }
          return false
        },
        dateFormat: '%b %d, %Y',
      },
      enabled: false,
      filename: formatExportFileName(title || 'export'),
    },
    legend: {
      align: 'center',
      alignColumns: false,
      enabled: true,
      itemMarginTop: 1,
      itemStyle: {
        fontSize: '1.2rem',
      },
      layout: 'horizontal',
      squareSymbol: !withOverallData,
      symbolHeight: withOverallData ? 0 : 12,
      symbolRadius: 0,
      symbolWidth: withOverallData ? 0 : 15,
      verticalAlign: 'top',
    },
    navigator: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: getGraphStackingOption(graphType),
      },
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    series: [],
    title: {
      text: '',
    },
  }
}
